import { FormItem } from '../../../../commons/Form/Form.types';
import { LoginCommercialFormSchema } from './LoginCommercialForm.types';

export const loginCommercialFormData: FormItem<LoginCommercialFormSchema>[][] = [
  [
    {
      name: 'email',
      placeholder: 'Votre adresse email...',
      label: 'Adresse email',
      type: 'text',
      required: true,
    },
  ],
  [
    {
      name: 'password',
      placeholder: 'Votre mot de passe...',
      label: 'Mot de passe',
      type: 'password',
      required: true,
    },
  ],
];
